import { takeLatest, call, put } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { deleteTripRequest, deleteTripResponse } from '../../slices/trip';

const queryString = require('query-string');

function* deleteTripWorker({ payload: { tripId, tripType } }) {
  try {
    const url = `trips/delete?${queryString.stringify(
      {
        tripId,
        tripType,
      },
      { skipNull: true },
    )}`;
    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (data) {
      yield put(deleteTripResponse({ tripId, tripType }));
    } else {
      yield put(
        deleteTripResponse({ tripId, error: 'Problem with your request, please try again later!' }),
      );
    }
  } catch (error) {
    let errorMsg = 'Problem with your request, please try again later!';
    if (error && error.response && error.response.data) {
      errorMsg = `${error.response.data.title} ${error.response.data.detail}. Please try again later!`;
    }
    yield put(deleteTripResponse({ tripId, error: errorMsg }));
  }
}

function* deleteTripWatcher() {
  yield takeLatest(deleteTripRequest.toString(), deleteTripWorker);
}

export default deleteTripWatcher;
